import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { PageHeader } from "@/components/common/page-header"
import { FilingsTable } from "@/features/filings/components/filings-table"
import { filingQueries } from "@/queries/filings"

const searchSchema = z.object({
  page: z.coerce.number().int().positive().catch(1),
})

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/_main/filings/"
)({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData(filingQueries.list(deps)),
  component: FilingsPage,
})

function FilingsPage() {
  const { page } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <>
      <PageHeader title="Filings" />
      <FilingsTable
        page={page}
        onPageChange={(next) => void navigate({ search: { page: next } })}
      />
    </>
  )
}
